import styled from '@emotion/styled';
import { BREAKPOINT_MEDIUM } from 'client/components/MarketingPagesShared/styles';

const Container = styled.div`
  padding: 130px 0;
  h2 {
    margin: 150px auto;
    font-size: 6rem;
    font-weight: 900;
    line-height: 7rem;
    max-width: 1060px;
    width: 100%;
  }
  button {
    margin-top: 50px;
  }
`;

const GridContainer = styled.div`
  margin: auto;
  max-width: 1240px;
  width: 100%;
  display: grid;
  grid-gap: 80px;
  grid-template-columns: repeat(4, minmax(15%, 250px));
  line-height: 2.6rem;
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    grid-gap: 40px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const SellingPoint = styled.div`
  svg {
    max-width: 150px;
    width: 100%;
  }
  h3 {
    font-size: 2rem;
    margin: 25px 0 20px;
  }
  p {
    font-size: 1.6rem;
  }
  @media (max-width: 600px) {
    svg {
      max-width: 150px;
    }
  }
`;

export { Container, GridContainer, SellingPoint };
